export enum PageModalType {
  CreateItem = 'CreateItem',
  SaveItem = 'SaveItem',
  EditItem = 'EditItem',
  DeleteItem = 'DeleteItem',
  CopyItem = 'CopyItem',
  None = 'None',
}
